
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import IssueDetailMixin from '~/mixins/issueDetailMixin'
import RepoDetailMixin from '~/mixins/repoDetailMixin'

export default defineComponent({
  name: 'IgnoreIssueTestFiles',
  mixins: [IssueDetailMixin, RepoDetailMixin, ActiveUserMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    checkId: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String
    },
    repositoryId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  async fetch(): Promise<void> {
    await this.fetchRepoDetails(this.baseRouteParams)
  },
  computed: {
    hasPatterns(): boolean {
      const testPatterns = this.repository.config?.test_patterns ?? []
      return testPatterns.length > 0
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {} as {
        repositoryId?: string
        checkId?: string
        issueShortcode?: string
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueTestPattern(params)
        this.$toast.success(`${this.issueShortcode} ignored for all test files.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore Issue',
          {
            method: 'Ignore Issue Test Files',
            ...params
          },
          'Something went wrong while ignoring this issue, please contact support.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
